import {importAllImages} from "@common-helpers/import-all-images"

const images = importAllImages(require.context('./img', false, /\.(png|jpe?g|svg)$/));

export const illustratedProgressConfig = {
    IllustratedProgress: {
        slides: [
            {
                image: images['1.svg'],
                title: 'Easy Fitness предлагает простое решение всё-в-одном',
            },
            {
                image: images['2.svg'],
                title: 'Занятия спортом с нами - это легко и удобно',
            },
            {
                image: images['3.svg'],
                title: 'Контроль за потребленными калориями, а не диеты – вот ключ к похудению',
            },
            {
                image: images['4.svg'],
                title: 'Наблюдение за собственным прогрессом – лучшая мотивация',
            },
            {
                image: images['5.svg'],
                title: 'С Easy Fitness вы останетесь надолго!',
            },
        ],
    },
    IllustratedProgressExt: {
        slides: [
            {
                image: images['1.svg'],
                title: 'Easy Fitness предлагает простое решение всё-в-одном',
            },
            {
                image: images['6.svg'],
                title: 'Мы научим выполнять упражнения правильно!',
            },
            {
                image: images['2.svg'],
                title: 'Занятия спортом с нами - это легко и удобно',
            },
            {
                image: images['7.svg'],
                title: 'С нами вы откроете новые возможности вашего тела!',
            },
            {
                image: images['3.svg'],
                title: 'Контроль за потребленными калориями, а не диеты – вот ключ к похудению',
            },
            {
                image: images['8.svg'],
                title: 'Easy Fitness поможет вам заботиться о своем здоровье!',
            },
            {
                image: images['4.svg'],
                title: 'Наблюдение за собственным прогрессом – лучшая мотивация',
            },
            {
                image: images['9.svg'],
                title: 'Вы будете удивлены своим результатам!',
            },
            {
                image: images['5.svg'],
                title: 'С Easy Fitness вы останетесь надолго!',
            },
        ],
    },
}